import Button from '@/Components/Button';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import { Head, useForm } from '@inertiajs/inertia-react';
import date from '@/helpers/date';
import Authenticated from '@/Layouts/Authenticated';
import Select from 'react-select';
import { useEffect } from 'react';
import { hasRole } from '@/helpers/user';
import Form from '@/Components/Products/Form';

const Create = (props) => {
    const { data, setData, processing, post } = useForm({
        'name': '',
        'price': '',
        'description': '',
        'branch_office_id': null,
        'softland_id': null,
        'branch_office_id': hasRole(props.auth.user, 'super_admin') ? null : props.auth.user.branch_office_id,
        'max_by_tickets_number': false,
        'max': '',
        'limit_per_schedule': '',
        'manual_stock': null,
        'manual_stock_type': null
    });

    const submit = (event) => {
        event.preventDefault();
        post(route('products.store'));
    }

    useEffect(() => {
        if (data.max_by_tickets_number) {
            setData('max', '');
        }
    }, [data.max_by_tickets_number]);

    useEffect(() => {
        if (data.max === '0') {
            setData('max', '');
        }
    }, [data.max])

    return (
        <Authenticated
            store={props.store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Crear producto</h2>}
        >
            <Head title="Crear producto - Cerogrado" />
            <Form
                onChange={({ name, value }) => setData(name, value)}
                onSelect={({ name, value }) => setData(name, value)}
                auth={props.auth}
                branchOffices={props.branchOffices}
                data={data}
                onSubmit={submit}
                processing={processing}
            />
        </Authenticated>
    )
}

export default Create;
